// extracted by mini-css-extract-plugin
export default {"field":"baseball-field_field__gC3oI","svg":"baseball-field_svg__6LVxn","overlay":"baseball-field_overlay__ycwUG","positionAnchor":"baseball-field_positionAnchor__eyWP8"};